import { mainApi } from '../../../../api/mainApi';
import { AccessState } from '../../../../types';
import { middlewareApi } from '../../../middleware/middlewareApi';
import { FilterArrow } from '../../../shared/components/tables/SearchPaginatedTable';
import { IResponse } from '../../../shared/interfaces/response.interface';

export const academicCounselorTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['Counselors'],
});
// Define a service using a base URL and expected endpoints
export const academicCounselorApi = academicCounselorTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET all Academic Offerings
     */
    getCounselors: builder.query<
      IResponse<any>,
      {
        page: number;
        perPage: number;
        search: string;
        offer?: number;
        educationLevel?: number;
        sort?: FilterArrow;
      }
    >({
      queryFn: async ({ offer, page, search, perPage, educationLevel, sort }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };
          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<IResponse<any>>(`/collaborators/academic/counseling`, {
            params: {
              user_profile_id,
              page,
              size: perPage,
              search,
              ...(sort && { type_sort: sort?.direction, sort: sort?.name }),
              ...(offer && { offer_id: offer }),
              ...(educationLevel && { education_level: educationLevel }),
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              //   ...result.data.map(({ id }) => ({ type: 'AcademicOfferings', id } as const)),
              { type: 'Counselors', id: 'LIST' },
            ]
          : [{ type: 'Counselors', id: 'LIST' }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCounselorsQuery } = academicCounselorApi;
